import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

// localStorage flags ki jagah ab URL dekh kar panel pata karte hain
function getActivePanelBroadcastConfig(baseUrl) {
  const path = window.location.pathname;

  if (path.startsWith("/rental-admin")) {
    return `${baseUrl}/rentaladmin/broadcasting/auth`;
  }
  if (path.startsWith("/mechanic-admin")) {
    return `${baseUrl}/mechanicadmin/broadcasting/auth`;
  }
  if (path.startsWith("/admin")) {
    return `${baseUrl}/superadmin/broadcasting/auth`;
  }
  return `${baseUrl}/customer/broadcasting/auth`;
}

let echoInstance = null;

export function getEcho(baseUrl) {
  const authEndpoint = getActivePanelBroadcastConfig(baseUrl);
  const token = localStorage.getItem("authToken");

  if (!authEndpoint || !token) {
    return null; // koi bhi panel logged in nahi
  }

  if (echoInstance) {
    return echoInstance;
  }

  echoInstance = new Echo({
    broadcaster: "pusher",
    key: process.env.REACT_APP_PUSHER_APP_KEY,
    cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER,
    forceTLS: true,
    authEndpoint,
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  });

  return echoInstance;
}

// Logout par zaroor call karo
export function disconnectEcho() {
  if (echoInstance) {
    echoInstance.disconnect();
    echoInstance = null;
  }
}